
import { Toast } from "vant";
import Header from "@/components/header/header.vue";
import VoucherItem from "@/components/voucher/voucher-list-item.vue";
import voucherEmpty from "@/components/voucher_empty.vue";
import downloadApp from '@/components/download/downloadApp.vue'

import { onMounted, inject, reactive, ref, toRefs, isReactive } from "vue";
import { useRouter } from "vue-router";
export default {
  components: {
    Header,
    VoucherItem,
    voucherEmpty,
    downloadApp
  },
  setup() {
    const $http: any = inject("$http");
    const router = useRouter();
    const product = reactive({
      size: 10,
      page: 1,
    });
    const active = ref(0);
    let isShowDownload = ref(false)

    const finished = ref(false);
    const loading = ref(false);
    const onLoad = async () => {
      get_voucher_list();
    };
    let voucherData: any = reactive({
      obj: [],
    });
    const onClick = () => {
      console.log("aaa", active.value);
      voucherData.obj = [];
      product.page = 1;
      finished.value = false;
      get_voucher_list();
    };
    //watch监听
    // watch(()=>active,(val:any)=>{
    // })
    const get_voucher_list = async () => {
      loading.value = true;
      const res = await $http.get_voucher_list({
        size: product.size,
        page: product.page,
        voucher_state: active.value + 1,
      });
      if (res.code === 200 && res.data) {
        product.page += 1;
        voucherData.obj = voucherData.obj.concat(res.data);
        if (res.data.length < product.size) {
          finished.value = true;
        }
        loading.value = false;
      }
    };

    return {
      voucherData,
      loading,
      finished,
      onLoad,
      active,
      onClick,
      isShowDownload
    };
  },
};
